import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  isShow: false,
  title: '',
  showCloseBtn: true,
  msg: '',
  btn: {
    confirm: {
      text: '',
      callback: null
    },
    cancel: {
      text: '',
      callback: null
    }
  }
};

const confirmSlice = createSlice({
  name: 'confirm',
  initialState,
  reducers: {
    showConfirm: (state, action) => ({
      isShow: true,
      title: action.payload.title,
      showCloseBtn: action.payload.showCloseBtn,
      msg: action.payload.msg,
      btn: { ...action.payload.btn }
    }),
    hideConfirm: (state) => ({
      ...initialState
    })
  }
});

export const { showConfirm, hideConfirm } = confirmSlice.actions;
export const useConfirmSliceSelector = createSelectorFn(confirmSlice);
export default confirmSlice;
